































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import PageRequest from '@/store/entities/page-request';
import moment from 'moment';
import appconst from '@/lib/appconst';

class ImageProductTaskSearchRequest extends PageRequest {
    batchName: string = '';
    productId: string = '';
    isExecuted: boolean | null = null;
    isSuccess: boolean | null = null;
    createTimeStart: Date | null = null;
    createTimeEnd: Date | null = null;
}

interface ImportForm {
    batchName: string;
    file: File | null;
}

@Component({
    name: 'ImageProductTaskManager'
})
export default class ImageProductTaskManager extends AbpBase {
    // 搜索参数
    searchRequest: ImageProductTaskSearchRequest = new ImageProductTaskSearchRequest();
    createTimeRange: Date[] = [];

    // 导入相关
    importModalShow: boolean = false;
    importLoading: boolean = true;
    importExcelUrl: string = '';
    importUploadData: any = {};
    headers: any = {};
    uploadKey: number = 0; // ★★★ 用于强制刷新Upload组件 ★★★

    importForm: ImportForm = {
        batchName: '',
        file: null
    };
    importRules = {
        batchName: [
            { required: true, message: '请输入批次名称', trigger: 'blur' }
        ],
        file: [
            { required: true, message: '请选择Excel文件', trigger: 'change' }
        ]
    };

    get defaultBatchName(): string {
        return moment().format('YYYYMMDDHHmmss');
    }

    // 列表数据
    get list(): any[] {
        return this.$store.state.imageProductTask.list;
    }
    get loading(): boolean {
        return this.$store.state.imageProductTask.loading;
    }
    get pageSize(): number {
        return this.$store.state.imageProductTask.pageSize;
    }
    get totalCount(): number {
        return this.$store.state.imageProductTask.totalCount;
    }
    get currentPage(): number {
        return this.$store.state.imageProductTask.currentPage;
    }

    // 表格列定义
    columns = [
        {
            title: '商品ID',
            key: 'productId',
            width: 200,
            fixed: 'left',
            render: (h: any, params: any) => {
                var row = params.row;
                var productId = row.productId || '';
                var country = '';
                var info = row.uploadInfo;
                if (info) {
                    try {
                        var data = JSON.parse(info);
                        country = data['国家/地区'] || '';
                    } catch {
                        // 忽略解析错误
                    }
                }
                var url = 'https://shop.tiktok.com/view/product/' + productId + '?region=' + country + '&local=en';
                return h('a', {
                    attrs: {
                        href: url,
                        target: '_blank',
                        title: '点击查看商品'
                    },
                    style: {
                        color: '#2d8cf0',
                        textDecoration: 'none'
                    }
                }, productId);
            }
        },
        {
            title: '商品图片',
            key: 'imageUrl',
            width: 120,
            render: (h: any, params: any) => {
                var url = params.row.imageUrl;
                if (url) {
                    return h('img', {
                        attrs: {
                            src: url,
                            preview: 'preview_' + params.row.id,
                            'preview-text': '商品图片'
                        },
                        style: {
                            width: '80px',
                            height: '80px',
                            objectFit: 'cover',
                            cursor: 'pointer',
                            borderRadius: '4px'
                        }
                    });
                }
                return h('span', '无');
            }
        },
        {
            title: '商品名称',
            key: 'productName',
            width: 200,
            render: (h: any, params: any) => {
                var info = params.row.uploadInfo;
                if (info) {
                    try {
                        var data = JSON.parse(info);
                        var name = data['商品名称'] || '';
                        return h('span', {
                            style: {
                                display: '-webkit-box',
                                WebkitLineClamp: '2',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }
                        }, name);
                    } catch {
                        return h('span', '');
                    }
                }
                return h('span', '');
            }
        },
        {
            title: '店铺名称',
            key: 'shopName',
            width: 150,
            render: (h: any, params: any) => {
                var info = params.row.uploadInfo;
                if (info) {
                    try {
                        var data = JSON.parse(info);
                        return h('span', data['店铺名称'] || '');
                    } catch {
                        return h('span', '');
                    }
                }
                return h('span', '');
            }
        },
        {
            title: '国家/地区',
            key: 'country',
            width: 120,
            render: (h: any, params: any) => {
                var info = params.row.uploadInfo;
                if (info) {
                    try {
                        var data = JSON.parse(info);
                        var country = data['国家/地区'] || '';
                        return h('span', country);
                    } catch {
                        return h('span', '');
                    }
                }
                return h('span', '');
            }
        },
        {
            title: '批次名称',
            key: 'batchName',
            width: 150
        },
        {
            title: '创建时间',
            key: 'createTime',
            width: 160,
            render: (h: any, params: any) => {
                var time = params.row.createTime;
                return h('span', time ? this.formatDateTime(time) : '');
            }
        },
        {
            title: '执行时间',
            key: 'executeTime',
            width: 160,
            render: (h: any, params: any) => {
                var time = params.row.executeTime;
                return h('span', time ? this.formatDateTime(time) : '-');
            }
        },
        {
            title: '是否执行',
            key: 'isExecuted',
            width: 100,
            render: (h: any, params: any) => {
                var executed = params.row.isExecuted;
                return h('Tag', {
                    props: {
                        color: executed ? 'success' : 'default'
                    }
                }, executed ? '已执行' : '未执行');
            }
        },
        {
            title: '是否成功',
            key: 'isSuccess',
            width: 100,
            render: (h: any, params: any) => {
                var success = params.row.isSuccess;
                if (!params.row.isExecuted) {
                    return h('span', '-');
                }
                return h('Tag', {
                    props: {
                        color: success ? 'success' : 'error'
                    }
                }, success ? '成功' : '失败');
            }
        },
        {
            title: '失败原因',
            key: 'failReason',
            width: 200,
            render: (h: any, params: any) => {
                var reason = params.row.failReason;
                if (reason) {
                    return h('span', {
                        style: { color: 'red' }
                    }, reason);
                }
                return h('span', '-');
            }
        }
    ];

    created() {
        this.headers = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        this.importExcelUrl = appconst.remoteServiceBaseUrl + 'api/services/app/ImageProduct/ImportTasks';
        this.getpage();
    }

    formatDateTime(date: any): string {
        if (!date) return '';
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }

    searchPage() {
        this.$store.commit('imageProductTask/setCurrentPage', 1);
        this.getpage();
    }

    resetSearch() {
        this.searchRequest = new ImageProductTaskSearchRequest();
        this.createTimeRange = [];
        this.getpage();
    }

    pageChange(page: number) {
        this.$store.commit('imageProductTask/setCurrentPage', page);
        this.getpage();
    }

    pagesizeChange(pagesize: number) {
        this.$store.commit('imageProductTask/setPageSize', pagesize);
        this.getpage();
    }

    async getpage() {
        this.searchRequest.maxResultCount = this.pageSize;
        this.searchRequest.skipCount = (this.currentPage - 1) * this.pageSize;

        if (this.createTimeRange && this.createTimeRange.length > 0) {
            if (this.createTimeRange[0]) {
                this.searchRequest.createTimeStart = this.createTimeRange[0];
            }
            if (this.createTimeRange[1]) {
                this.searchRequest.createTimeEnd = this.createTimeRange[1];
            }
        }

        await this.$store.dispatch({
            type: 'imageProductTask/getTaskList',
            data: this.searchRequest
        });
    }

    // ================= 导入相关 =================

    // ★★★ 打开导入弹窗 ★★★
    openImportModal() {
        // 直接调用方法获取当前时间
        const now = moment().format('YYYYMMDDHHmmss');
        this.importForm.batchName = now;
        // 强制更新 importUploadData，触发响应式
        this.importUploadData = {
            batchName: now
        };
        // 清空文件
        this.importForm.file = null;
        // 强制刷新Upload组件
        this.uploadKey = this.uploadKey + 1;
        this.importModalShow = true;
        // 重置表单验证
        this.$nextTick(() => {
            var importFormRef: any = this.$refs.importFormRef;
            if (importFormRef) {
                importFormRef.resetValidation();
            }
        });
    }

    @Watch('importForm.batchName')
    onBatchNameChange(newVal: string) {
        if (this.importModalShow) {
            this.importUploadData = {
                batchName: newVal || ''
            };
        }
    }

    beforeImportUpload(file: any) {
        var isValidType = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
        if (!isValidType) {
            this.$Message.error('请上传Excel文件（.xlsx或.xls格式）');
            return false;
        }
        var isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            this.$Message.error('文件大小不能超过10MB');
            return false;
        }
        this.importForm.file = file;
        var importFormRef: any = this.$refs.importFormRef;
        if (importFormRef) {
            importFormRef.validateField('file');
        }
        return true;
    }

    // ★★★ 导入成功回调 ★★★
    handleImportSuccess(res: any, file: any, fileList: any) {
        this.importLoading = false;
        setTimeout(() => {
            this.importLoading = true;
        }, 500);

        if (res && res.success === true) {
            this.$Message.success('导入成功！');
            this.importModalShow = false;
            // ★★★ 刷新批次号 ★★★
            this.importForm.batchName = this.defaultBatchName;
            this.importUploadData = {
                batchName: this.importForm.batchName
            };
        } else {
            var errorMsg = '导入失败';
            if (res && res.error && res.error.message) {
                errorMsg = res.error.message;
            } else if (res && res.message) {
                errorMsg = res.message;
            }
            this.$Message.error(errorMsg);
        }
    }

    getErrorMessage(error: any): string {
        if (error && error.error && error.error.message) {
            return error.error.message;
        }
        if (error && error.message) {
            return error.message;
        }
        return '导入失败，请检查网络或联系管理员';
    }

    // ★★★ 导入失败回调 ★★★
    handleImportError(error: any, file: any, fileList: any) {
        this.importLoading = false;
        setTimeout(() => {
            this.importLoading = true;
        }, 500);

        var errorMsg = '导入失败，请检查网络或联系管理员';

        // ★★★ 错误信息直接在 file 中 ★★★
        if (file && file.error && file.error.message) {
            errorMsg = file.error.message;
        } else if (file && file.message) {
            errorMsg = file.message;
        }

        this.$Message.error(errorMsg);
    }

    cancelImport() {
        this.importModalShow = false;
        this.importForm.file = null;
    }

    // ★★★ 确认导入 ★★★
    confirmImport() {
        // 由 Upload 组件自动处理，但需要检查是否有文件
        if (!this.importForm.file) {
            this.$Message.warning('请先选择Excel文件');
            return;
        }
        // 由 Upload 组件自动上传
    }

    downloadTemplate() {
        var templateUrl = window.location.origin + "/template/ImageTemplate.xlsx";
        window.open(templateUrl);
    }
}
